export type FacultyType = {
  id: string;
  Description: {
    value: string;
  };
};

export type Faculty = {
  id: string;
  Name: {
    value: string;
  };
  Title: {
    value: string;
  };
  Type: {
    jsonValue: {
      fields: {
        Description: {
          value: string;
        };
      };
    };
  };
  Email: {
    value: string;
  };
  Gender: {
    value: string;
  };
  Phone: {
    value: string;
  };
  Photo: {
    jsonValue: {
      value: {
        alt: string;
        src: string;
      };
    };
  };
};

export type TitleMapping = {
  faculty: string;
  staff: string;
  administration: string;
  boardmembers: string;
  all: string;
};
